(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/aria-utils/assets/javascripts/compose-result-update-text.js') >= 0) return;  svs.modules.push('/components/pool-betting/aria-utils/assets/javascripts/compose-result-update-text.js');
"use strict";


const {
  EventTypeId,
  EventTypeDescriptions
} = svs.components.sportinfo.common.constants;
const {
  SportTypes
} = svs.components.sport.sportTypes;
const composeUpdateResultTextDefault = _ref => {
  let {
    eventDescription,
    eventNumber,
    numberOfGoalsHomeTeam,
    numberOfGoalsAwayTeam,
    periodNumber
  } = _ref;
  const isPeriod = periodNumber > 0;
  if (isPeriod) {
    return "\xC4ndrat resultat f\xF6r period ".concat(periodNumber, ", ").concat(eventDescription, ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
  }
  return "\xC4ndrat resultat f\xF6r event ".concat(eventNumber, ", ").concat(eventDescription, ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
};
const composeUpdateResultText1X2 = _ref2 => {
  let {
    eventComment,
    eventDescription,
    eventNumber,
    eventTypeId,
    numberOfGoalsHomeTeam,
    numberOfGoalsAwayTeam,
    outcome
  } = _ref2;
  if (eventTypeId === EventTypeId.AMOUNT || eventTypeId === EventTypeId.EVENT_1_2 || eventTypeId === EventTypeId.HEAD_TO_HEAD || eventTypeId === EventTypeId.OVER_UNDER || eventTypeId === EventTypeId.LEAST_AMOUNT_OF_GOALS) {
    return "\xC4ndrat utfall f\xF6r event ".concat(eventNumber, ", ").concat(eventDescription, ", ").concat(eventComment || EventTypeDescriptions[eventTypeId], ".\n          Utfall ").concat(outcome ? outcome : 'Ej spelbart alternativ', ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
  }
  return "\xC4ndrat utfall f\xF6r match ".concat(eventNumber, ", ").concat(eventDescription, ".\n          Utfall ").concat(outcome ? outcome : '-', ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
};
const composeUpdateResultTextTrotting = _ref3 => {
  let {
    eventDescription,
    eventNumber,
    outcome
  } = _ref3;
  return "\xC4ndrat utfall f\xF6r match ".concat(eventNumber, ", ").concat(eventDescription, ". Utfall ").concat(outcome ? outcome : '-', ".");
};
const composeResultUpdateText = _ref4 => {
  let {
    eventComment,
    eventTypeId,
    eventNumber,
    eventDescription,
    numberOfGoalsHomeTeam,
    numberOfGoalsAwayTeam,
    outcome,
    periodNumber,
    sportType
  } = _ref4;
  const isTrotting = sportType && sportType === SportTypes.Trotting;
  if (isTrotting) {
    return composeUpdateResultTextTrotting({
      eventDescription,
      eventNumber,
      outcome
    });
  }
  const isHead2Head = eventTypeId === EventTypeId.HEAD_TO_HEAD;
  let changedResultText;
  if (eventTypeId === EventTypeId.RESULT) {
    changedResultText = composeUpdateResultTextDefault({
      eventTypeId,
      eventComment,
      eventDescription,
      eventNumber,
      numberOfGoalsHomeTeam,
      numberOfGoalsAwayTeam,
      periodNumber
    });
  } else {
    changedResultText = composeUpdateResultText1X2({
      eventDescription,
      eventNumber,
      eventTypeId,
      isHead2Head,
      numberOfGoalsHomeTeam,
      numberOfGoalsAwayTeam,
      outcome
    });
  }
  return changedResultText;
};
setGlobal('svs.components.poolBetting.ariaUtils', {
  composeResultUpdateText,
  composeUpdateResultText1X2
});

 })(window);